import { useEffect, useCallback } from 'react';
import { useAppDispatch, useAppSelector } from './reduxHooks';
import { fetchBalance } from '../store/slices/balanceSlice';
import type { BalanceResponse } from '../types/balance.types';

export interface UseBalanceResult {
  balance: BalanceResponse | null;
  balanceLoading: boolean;
  balanceError: boolean;
  refreshBalance: () => void;
}

export function useBalance(): UseBalanceResult {
  const dispatch = useAppDispatch();
  const { data, status } = useAppSelector((state) => state.balance);

  useEffect(() => {
    if (data === null) {
      void dispatch(fetchBalance());
    }
  }, [data, dispatch]);

  const refreshBalance = useCallback(() => {
    void dispatch(fetchBalance());
  }, [dispatch]);

  return {
    balance: data,
    balanceLoading: status === 'loading',
    balanceError: status === 'error',
    refreshBalance,
  };
}
